import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "./input-types";

export const APPLICANT_COL_NAMES = new OrderedMap({
    name: {
        title: "Name",
        key: "name",
        dataIndex: "name",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    gender: {
        title: "Gender",
        key: "gender",
        dataIndex: "gender",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    dob: {
        title: "DOB",
        key: "dob",
        dataIndex: "dob",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    phone: {
        title: "Phone",
        key: "phone",
        dataIndex: "phone",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    email: {
        title: "Email",
        key: "email",
        dataIndex: "email",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    nature_of_association: {
        title: "Association",
        key: "nature_of_association",
        dataIndex: "nature_of_association",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    pan: {
        title: "PAN",
        key: "pan",
        dataIndex: "pan",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    present_address: {
        title: "Present Address",
        key: "present_address",
        dataIndex: "present_address",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    }
});

export const BANK_ACCOUNT_DETAILS = new OrderedMap({
    account_entity: {
        title: "A/C Entity",
        key: "account_entity",
        dataIndex: "account_entity",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    account_type: {
        title: "Account Type",
        key: "account_type",
        dataIndex: "account_type",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    account_holder_name: {
        title: "A/C Holder Name",
        key: "account_holder_name",
        dataIndex: "account_holder_name",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    account_number: {
        title: "Account Number",
        key: "account_number",
        dataIndex: "account_number",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    ifsc_code: {
        title: "IFSC Code",
        key: "ifsc_code",
        dataIndex: "ifsc_code",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    }
});

export const CIBIL_DETAILS = new OrderedMap({
    name: {
        title: "Name",
        key: "name",
        dataIndex: "name",
        editable: false,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    pan: {
        title: "PAN",
        key: "pan",
        dataIndex: "pan",
        editable: false,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    dob: {
        title: "DOB",
        key: "dob",
        dataIndex: "dob",
        editable: false,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    address: {
        title: "Address",
        key: "address",
        dataIndex: "address",
        editable: false,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    phone: {
        title: "Phone",
        key: "phone",
        dataIndex: "phone",
        editable: false,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    score: {
        title: "CIBIL Score",
        key: "score",
        dataIndex: "score",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    }
});

export const BANK_STATEMENT_COLS = new OrderedMap({
    months: {
        title: "Months",
        key: "months",
        dataIndex: "months",
        editable: false
    },
    fifth_balance: {
        title: "5th Balance",
        key: "fifth_balance",
        dataIndex: "fifth_balance",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    fifteen_balance: {
        title: "15th Balance",
        key: "fifteen_balance",
        dataIndex: "fifteen_balance",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    tewnty_fifth: {
        title: "25th Balance",
        key: "tewnty_fifth",
        dataIndex: "tewnty_fifth",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    no_of_inward_cheques: {
        title: "No of Inward Cheques",
        key: "no_of_inward_cheques",
        dataIndex: "no_of_inward_cheques",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    no_of_outward_cheques: {
        title: "No of Outward Cheques",
        key: "no_of_outward_cheques",
        dataIndex: "no_of_outward_cheques",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    inward_cheque_bounce: {
        title: "Inward Cheque Bounce",
        key: "inward_cheque_bounce",
        dataIndex: "inward_cheque_bounce",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    },
    outward_cheque_bounce: {
        title: "Outward Cheque Bounce",
        key: "outward_cheque_bounce",
        dataIndex: "outward_cheque_bounce",
        editable: true,
        onCellGenerator: (handleSave, _) => record => ({
            record,
            editable: true,
            dataIndex: _.dataIndex,
            title: _.title,
            handleSave
        })
    }
});

export const Stats = new OrderedMap({
    avg_monthly_no_sales: {
        title: "Avg. Monthly #Sales"
    },
    avg_monthly_no_repayments: {
        title: "Avg. Monthly #Repayments"
    },
    no_bounces: {
        title: "Bounces #%"
    },
    repayment_period_mean: {
        title: "Avg. Repayment Period"
    },
    no_dpd_95_perc_amt_gt_0: {
        title: "DPD #%"
    },
    no_dpd_95_perc_amt_gt_30: {
        title: "DPD > 30 #%"
    },
    no_dpd_95_perc_amt_gt_60: {
        title: "DPD > 60 #%"
    },
    no_dpd_95_perc_amt_gt_90: {
        title: "DPD > 90 #%"
    },
    retailer_share_of_the_total_sales_perc: {
        title: "% Share Sales"
    },
    score_obtained: {
        title: "Score (1000)"
    }
});

export const CAMS_VIEW_STATUS_LOGS_COLUMNS = () =>  new OrderedMap({
    stage: {
        title:"Stage",
        dataIndex:"stage", 
        key: "stage", 
        width: 50,
    },
    remark: {
        title:"Remarks",
        dataIndex:"remark", 
        key: "remark", 
        width: 50,
    },
    userName: {
        title:"User",
        dataIndex:"userName", 
        key: "userName", 
        width: 50,
    },
    breachedStatus: {
        title:"Status",
        dataIndex:"breachedStatus", 
        key: "breachedStatus", 
        width: 50,
    },
    levelOfAuthority: {
        title:"Level of Authority",
        dataIndex:"levelOfAuthority", 
        key: "levelOfAuthority", 
        width: 50,
    }
})
export const CATEGORY_BG_CLASS = {
  Profile: 'bg-profile',
  General: 'bg-general',
  Ledger: 'bg-ledger',
  Banking: 'bg-banking',
  GST: 'bg-gst',
  Financial: 'bg-financial',
  Geography: 'bg-geography',
  DB: 'bg-db',
  Anchor: 'bg-anchor',
  'Anchor MPA': 'bg-anchor-mpa',
  Bureau: 'bg-bureau',
  MPA: 'bg-mpa',
  Financials: 'bg-financials',
};

export const CAMS_VIEW_COLUMNS = (getCustomTag) =>  new OrderedMap({
    s_no: {
        title:"S.No",
        dataIndex:"s_no", 
        key: "s_no", 
        width: 50,
        editable: false,
        render:(_, k, index) => index+1,
        breachedPara: true,
        onCell: (record) => ({
            className: CATEGORY_BG_CLASS[record.category] || 'bg-default',
        }),
    },
     category: {
        title:"Category",
        dataIndex:"category",
        key: "category",
        width: 70,
        editable: false,
        breachedPara: true,
        onCell: (record) => ({
            className: CATEGORY_BG_CLASS[record.category] || 'bg-default',
        }),

    },
    fact_name: {
        title:"Parameter", 
        dataIndex:"fact_name", 
        key:"fact_name", 
        width: 200,
        editable: false,
        breachedPara: true
    },
    policy: {
        title:"Policy", 
        dataIndex:"policy", 
        key:"policy", 
        width: 200, 
        render : (_)  => String(_),
        editable: false,
        breachedPara: true
    },
    fact_value: {
        title:"Value", 
        dataIndex:"fact_value", 
        key:"fact_value", 
        width: 130,
        editable: false,
        breachedPara: true
    },
    output: {
        title:"Output", 
        dataIndex:"output",
        key:"output", 
        width: 80, 
        render: (_) => getCustomTag(_ , "output"),
        editable: false,
        breachedPara: true
    },
    approval_level: {
        title:"Approval Level", 
        dataIndex:"approval_level", 
        key:"approval_level", 
        align: "center",
        width: 70,
        editable: false,
        breachedPara: true
    },
    deviation: {
        title:"Deviation", 
        dataIndex:"deviation", 
        key:"deviation", 
        width: 130, 
        render: (_) => getCustomTag(_ , "deviation"),
        editable: false,
        breachedPara: false
    },
    credit_remarks: {
        title: "Credit Remarks",
        key: "credit_remarks",
        dataIndex: "credit_remarks",
        fieldType: INPUT_TYPES.TEXTAREA,
        editable: true,
        width: 150, 
        breachedPara: true
    },
});
export const CAMS_VIEW_COLUMNS_DEMO = (getCustomTag) =>  new OrderedMap({
     category: {
        title:"Category",
        dataIndex:"category",
        key: "category",
        width: 70,
        editable: false
    },
    fact_name: {
        title:"Parameter", 
        dataIndex:"fact_name", 
        key:"fact_name", 
        width: 200,
        editable: false
    },
    policy: {
        title:"Policy", 
        dataIndex:"policy", 
        key:"policy", 
        width: 200, 
        render : (_)  => String(_),
        editable: false
    },
    fact_value: {
        title:"Value", 
        dataIndex:"fact_value", 
        key:"fact_value", 
        width: 100,
        editable: false
    },
    output: {
        title:"Output", 
        dataIndex:"output",
        key:"output", 
        width: 100, 
        render: (_) => getCustomTag(_ , "output"),
        editable: false
    },
    approval_level: {
        title:"Approval Level", 
        dataIndex:"approval_level", 
        key:"approval_level", 
        align: "center",
        width: 70,
        editable: false
    },
    deviation: {
        title:"Deviation", 
        dataIndex:"deviation", 
        key:"deviation", 
        width: 100, 
        render: (_) => getCustomTag(_ , "deviation"),
        editable: false
    },
    credit_remarks: {
        title: "Credit Remarks",
        key: "credit_remarks",
        dataIndex: "credit_remarks",
        fieldType: INPUT_TYPES.TEXTAREA,
        editable: true,
        width: 150, 
    },
});


export const CAMS_VIEW_FOUNDERS = (getCustomTag) =>  new OrderedMap({
    s_no: {
        title:"S.No",
        dataIndex:"s_no", 
        key: "s_no", 
        width: 35,
        editable: false,
        render:(_, k, index) => index+1,
        breachedPara: true,
        onCell: (record) => ({
            className: CATEGORY_BG_CLASS[record.category] || 'bg-default',
        }),
    },
     category: {
        title:"Category",
        dataIndex:"category",
        key: "category",
        width: 55,
        editable: false,
        breachedPara: true,
        onCell: (record) => ({
            className: CATEGORY_BG_CLASS[record.category] || 'bg-default',
        }),

    },
    fact_name: {
        title:"Parameter", 
        dataIndex:"fact_name", 
        key:"fact_name", 
        width: 200,
        editable: false,
        breachedPara: true
    },
    policy: {
        title:"Policy", 
        dataIndex:"policy", 
        key:"policy", 
        width: 200, 
        render : (_)  => String(_),
        editable: false,
        breachedPara: true
    },
    fact_value: {
        title:"Value", 
        dataIndex:"fact_value", 
        key:"fact_value", 
        width: 130,
        editable: false,
        breachedPara: true
    },
    output: {
        title:"Output", 
        dataIndex:"output",
        key:"output", 
        width: 65, 
        render: (_) => getCustomTag(_ , "output"),
        editable: false,
        breachedPara: true
    },
    approval_level: {
        title:"Approval Level", 
        dataIndex:"approval_level", 
        key:"approval_level", 
        align: "center",
        width: 60,
        editable: false,
        breachedPara: true
    },
    deviation: {
        title:"Deviation", 
        dataIndex:"deviation", 
        key:"deviation", 
        width: 130, 
        render: (_) => getCustomTag(_ , "deviation"),
        editable: false,
        breachedPara: false
    },
      credit_remarks: {
        title: "Credit Remarks",
        dataIndex: "credit_remarks",
        key: "credit_remarks",
        width: 160,
        editable: false,
        breachedPara: true
    },
});


export const CAMS_VIEW_COLUMNS_NEW = (getCustomTag) =>  new OrderedMap({
    s_no: {
        title:"S.No",
        dataIndex:"s_no", 
        key: "deviation", 
        width: 50,
        editable: false,
        render:(_, k, index) => index+1
    },
    //  category: {
    //     title:"Category",
    //     dataIndex:"category",
    //     key: "category",
    //     width: 70,
    //     editable: false
    // },
    fact_name: {
        title:"Parameter", 
        dataIndex:"fact_name", 
        key:"fact_name", 
        width: 200,
        editable: false,
        align: "left"
    },
    policy: {
        title:"Policy", 
        dataIndex:"policy", 
        key:"policy", 
        width: 150, 
        render : (_)  => String(_),
        editable: false,
        align: "left"
    },
    fact_value: {
        title:"Value", 
        dataIndex:"fact_value", 
        key:"fact_value", 
        width: 50,
        editable: false,
        align: "left"
    },
    output: {
        title:"Output", 
        dataIndex:"output",
        key:"output", 
        width: 150, 
        editable: false,
        align: "center",
        render: (_) => getCustomTag(_ , "output"),
    },
    // approval_level: {
    //     title:"Approval Level", 
    //     dataIndex:"approval_level", 
    //     key:"approval_level", 
    //     align: "center",
    //     width: 70,
    //     editable: false
    // },
    // deviation: {
    //     title:"Deviation", 
    //     dataIndex:"deviation", 
    //     key:"deviation", 
    //     width: 100, 
    //     render: (_) => getCustomTag(_ , "deviation"),
    //     editable: false
    // },
    // credit_remarks: {
    //     title: "Credit Remarks",
    //     key: "credit_remarks",
    //     dataIndex: "credit_remarks",
    //     fieldType: INPUT_TYPES.TEXTAREA,
    //     editable: true,
    //     width: 150, 
    // },
});

export const DEVIATION_MATRIX_COLUMNS = (getCustomTag) => new OrderedMap({
    parameter: {
        title:"Parameters",
        dataIndex:"parameter", 
        key: "parameter", 
        width: 200,
        editable: false,
        align: "center"
    },
    entered_value: {
        title:"Entered Value",
        dataIndex:"entered_value",
        key: "entered_value",
        width: 200,
        editable: false,
        align: "center",
    },
    condition: {
        title:"Condition", 
        dataIndex:"condition", 
        key:"condition", 
        width: 200,
        editable: false,
        align: "center",
    },
    result: {
        title:"Result", 
        dataIndex:"result", 
        key:"result", 
        width: 200, 
        editable: false,
        render : (_)  => getCustomTag(_, "result"),
        align: "center",
    },
    mitigant: {
        title:"Mitigant", 
        dataIndex:"mitigant", 
        key:"mitigant", 
        width: 200,
        fieldType: INPUT_TYPES.TEXTAREA,
        render: (_) => getCustomTag(_),
        align: "center",
        editable: true,
    },
});
